/**
 * Enrollments API Client
 * Endpoints para gestión de enrollments
 */

import { apiClient } from './client';
import type { Enrollment } from '@/types/enrollment';

export interface EnrollmentToken {
  id: string;
  organizationId: string;
  enrollmentToken: string;
  expiresAt: string;
}

export const enrollmentsApi = {
  createOrganizationToken: async (organizationId: string): Promise<EnrollmentToken> =>
    (await apiClient.post<EnrollmentToken>('/organization-enrollment-tokens', { organizationId }))
      .data,

  /**
   * Get all pending enrollments
   */
  getPendingEnrollments: async (): Promise<Enrollment[]> => {
    const response = await apiClient.get<Enrollment[]>('/enrollments/pending');
    return response.data;
  },

  /**
   * Get all rejected enrollments
   */
  getRejectedEnrollments: async (): Promise<Enrollment[]> => {
    const response = await apiClient.get<Enrollment[]>('/enrollments/rejected');
    return response.data;
  },

  /**
   * Approve an enrollment
   */
  approveEnrollment: async (enrollmentId: string): Promise<Enrollment> => {
    const response = await apiClient.post<Enrollment>(`/enrollments/${enrollmentId}/approve`);
    return response.data;
  },

  /**
   * Delete/reject an enrollment
   */
  deleteEnrollment: async (enrollmentId: string): Promise<void> => {
    await apiClient.delete(`/enrollments/${enrollmentId}`);
  },
};
